import { Button, Menu, MenuItem } from '@mui/material'
import { useOptionalUser } from '@src/providers/UserProvider'
import { useState, type JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const FinancialEngineerMenu = (): JSX.Element | null => {
  const { t } = useTranslation()
  const user = useOptionalUser()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  if (!user?.rights.canRunTreeSimulation) {
    return null
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <Button
        id="btnFinancialEngineer"
        aria-controls={open ? 'financial-engineer-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        {t('menus.financialEngineer.title')}
      </Button>
      <Menu
        id="financial-engineer-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            navigate('/financial-engineer/tree-simulations')
            handleClose()
          }}
        >
          {t('menus.financialEngineer.treeSimulations')}
        </MenuItem>
      </Menu>
    </div>
  )
}

export default FinancialEngineerMenu
